// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const CreateDesignation = () => {
//   const [companyName, setCompanyName] = useState('');
//   const [designation, setDesignation] = useState('Contractor');
//   const [data, setData] = useState([]);
//   const [filter, setFilter] = useState('All');
//   const [message, setMessage] = useState('');
//   const [currentPage, setCurrentPage] = useState(1); // Pagination state
//   const itemsPerPage = 10; // Number of items per page
//   const projectId = localStorage.getItem('selectedProject');
//   const baseURL = process.env.REACT_APP_API_BASE_URL;

//   useEffect(() => {
//     fetchDesignations();
//   }, []);

//   const fetchDesignations = async () => {
//     try {
//       const response = await apiClient.get(`get_designations?projectId=${projectId}`);
//       transformAndSetData(response.data);
//     } catch (error) {
//       console.error('Error fetching designations:', error);
//     }
//   };

//   const transformAndSetData = (apiData) => {
//     const transformedData = [];
//     let designationData = apiData;

//     if (apiData.data) {
//       designationData = apiData.data;
//       setMessage(apiData.message || '');
//       // Set timer to clear message after 5 seconds
//       setTimeout(() => setMessage(''), 5000);
//     } else {
//       setMessage('');
//     }

//     Object.entries(designationData).forEach(([designation, employees]) => {
//       Object.entries(employees).forEach(([name, details]) => {
//         transformedData.push({
//           companyName: name,
//           designation: designation,
//           details: details
//         });
//       });
//     });

//     setData(transformedData);
//     setCurrentPage(1); // Reset to first page when data updates
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const payload = {
//       projectId,
//       CreateDesignation: {
//         SelectedDesignation: designation,
//         CompanyName: companyName,
//       }
//     };

//     try {
//       const response = await apiClient.post(`create_designation`, payload);
//       console.log('Data sent successfully:', response.data);
//       transformAndSetData(response.data);
//       setCompanyName('');
//       setDesignation('Contractor');
//     } catch (error) {
//       console.error('Error sending data:', error);
//     }
//   };

//   const filteredData = filter === 'All' 
//     ? data 
//     : data.filter(item => item.designation === filter);

//   // Pagination logic
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   return (
//     <div className="w-full rounded-lg flex flex-col items-center">
//       <h1 className="text-2xl font-bold text-gray-800">Create and View Designations</h1>
//       <form className="w-full mt-4 p-4 bg-gray-50 rounded-lg shadow-md" onSubmit={handleSubmit}>
//         <div className="grid grid-cols-2 gap-4 mb-4">
//           <input
//             type="text"
//             value={companyName}
//             onChange={(e) => setCompanyName(e.target.value)}
//             placeholder="Company Name"
//             className="p-2 border rounded-md"
//           />
//           <select
//             value={designation}
//             onChange={(e) => setDesignation(e.target.value)}
//             className="p-2 border rounded-md"
//           >
//             <option value="Contractor">Contractor</option>
//             <option value="Scanning Operator">Scanning Operator</option>
//           </select>
//         </div>
//         <div className='flex justify-center'>
//           <button
//             type="submit"
//             className="bg-[#424752] text-white py-2 px-4 rounded-lg shadow-md hover:bg-gray-500 transition duration-300"
//           >
//             Submit
//           </button>
//         </div>
//       </form>

//       {/* Display success message with timer */}
//       {message && (
//         <div className="mt-4 w-full max-w-4xl bg-green-100 p-4 rounded-lg text-green-800">
//           {message}
//         </div>
//       )}

//       <div className="mt-6 w-full bg-gray-50 p-4 rounded-lg shadow-md">
//         <select
//           value={filter}
//           onChange={(e) => {
//             setFilter(e.target.value);
//             setCurrentPage(1); // Reset to first page on filter change
//           }}
//           className="p-2 mb-4 border rounded-md"
//         >
//           <option value="All">All</option>
//           <option value="Contractor">Contractor</option>
//           <option value="Scanning Operator">Scanning Operator</option>
//         </select>
//         <table className="min-w-full rounded-t-lg shadow-md">
//           <thead className='bg-[#424752] text-white rounded-t-lg'>
//             <tr>
//               <th className="py-2 px-4 border-b">Company Name</th>
//               <th className="py-2 px-4 border-b">Designation</th>
//             </tr>
//           </thead>
//           <tbody className='bg-white text-gray-800 text-center'>
//             {paginatedData.map((item, index) => (
//               <tr key={index}>
//                 <td className="py-2 px-4 border-b">{item.companyName}</td>
//                 <td className="py-2 px-4 border-b">{item.designation}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {/* Pagination Controls */}
//         {totalPages > 1 && (
//           <div className="mt-4 flex justify-center items-center gap-2">
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="px-3 py-1 bg-[#424752] text-white rounded-md disabled:opacity-50 hover:bg-gray-500"
//             >
//               Previous
//             </button>
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="px-3 py-1 bg-[#424752] text-white rounded-md disabled:opacity-50 hover:bg-gray-500"
//             >
//               Next
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CreateDesignation;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import apiClient from '../../../pages/keycloak/axiosInstance';

const CreateDesignation = () => {
  const [companyName, setCompanyName] = useState('');
  const [designation, setDesignation] = useState('Contractor');
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState('All');
  const [message, setMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const projectId = localStorage.getItem('selectedProject');
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // ← Only added: Role check
  const [canCreate, setCanCreate] = useState(false);

  // ← Only added: Check role on mount
  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setCanCreate(roles.includes("Create_Designation"));
    }
  }, []);

  useEffect(() => {
    fetchDesignations();
  }, []);

  const fetchDesignations = async () => {
    try {
      const response = await apiClient.get(`get_designations?projectId=${projectId}`);
      transformAndSetData(response.data);
    } catch (error) {
      console.error('Error fetching designations:', error);
    }
  };

  const transformAndSetData = (apiData) => {
    const transformedData = [];
    let designationData = apiData;

    if (apiData.data) {
      designationData = apiData.data;
      setMessage(apiData.message || '');
      setTimeout(() => setMessage(''), 5000);
    } else {
      setMessage('');
    }

    Object.entries(designationData).forEach(([designation, employees]) => {
      Object.entries(employees).forEach(([name, details]) => {
        transformedData.push({
          companyName: name,
          designation: designation,
          details: details
        });
      });
    });

    setData(transformedData);
    setCurrentPage(1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      projectId,
      CreateDesignation: {
        SelectedDesignation: designation,
        CompanyName: companyName,
      }
    };

    try {
      const response = await apiClient.post(`create_designation`, payload);
      console.log('Data sent successfully:', response.data);
      transformAndSetData(response.data);
      setCompanyName('');
      setDesignation('Contractor');
    } catch (error) {
      console.error('Error sending data:', error);
    }
  };

  const filteredData = filter === 'All' 
    ? data 
    : data.filter(item => item.designation === filter);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="w-full rounded-lg flex flex-col items-center">
      <h1 className="text-2xl font-bold text-gray-800">Create and View Designations</h1>
      <form className="w-full mt-4 p-4 bg-gray-50 rounded-lg shadow-md" onSubmit={handleSubmit}>
        <div className="grid grid-cols-2 gap-4 mb-4">
          <input
            type="text"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder="Company Name"
            className="p-2 border rounded-md"
          />
          <select
            value={designation}
            onChange={(e) => setDesignation(e.target.value)}
            className="p-2 border rounded-md"
          >
            <option value="Contractor">Contractor</option>
            <option value="Scanning Operator">Scanning Operator</option>
          </select>
        </div>
        <div className='flex justify-center'>
          {/* ← Only changed: Conditional Submit button */}
          {canCreate ? (
            <button
              type="submit"
              className="bg-[#424752] text-white py-2 px-4 rounded-lg shadow-md hover:bg-gray-500 transition duration-300"
            >
              Submit
            </button>
          ) : (
            <p className="text-red-600 font-medium">You don't have permission to create designation</p>
          )}
        </div>
      </form>

      {/* Display success message with timer */}
      {message && (
        <div className="mt-4 w-full max-w-4xl bg-green-100 p-4 rounded-lg text-green-800">
          {message}
        </div>
      )}

      <div className="mt-6 w-full bg-gray-50 p-4 rounded-lg shadow-md">
        <select
          value={filter}
          onChange={(e) => {
            setFilter(e.target.value);
            setCurrentPage(1);
          }}
          className="p-2 mb-4 border rounded-md"
        >
          <option value="All">All</option>
          <option value="Contractor">Contractor</option>
          <option value="Scanning Operator">Scanning Operator</option>
        </select>
        <table className="min-w-full rounded-t-lg shadow-md">
          <thead className='bg-[#424752] text-white rounded-t-lg'>
            <tr>
              <th className="py-2 px-4 border-b">Company Name</th>
              <th className="py-2 px-4 border-b">Designation</th>
            </tr>
          </thead>
          <tbody className='bg-white text-gray-800 text-center'>
            {paginatedData.map((item, index) => (
              <tr key={index}>
                <td className="py-2 px-4 border-b">{item.companyName}</td>
                <td className="py-2 px-4 border-b">{item.designation}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="mt-4 flex justify-center items-center gap-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-3 py-1 bg-[#424752] text-white rounded-md disabled:opacity-50 hover:bg-gray-500"
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-3 py-1 bg-[#424752] text-white rounded-md disabled:opacity-50 hover:bg-gray-500"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateDesignation;